import * as React from 'react'

import { LoginHeading } from '@ally/ally-login'
import { Button, Space, TextBody } from '@ally/metronome-ui'
import { AddAutoAccountSuccessProps } from '@ally/transmitigator'

import { useTransmit } from '../../TransmitContext'
import { AccountDetails, StyledTextBody } from '../Shared'

const AddAutoAccountSuccessContent: React.FC<AddAutoAccountSuccessProps> = ({
  onComplete,
  status,
  username,
  userData,
  error,
}) => {
  const textBodyBlock = userData ? (
    <StyledTextBody size="sm" tag="p">
      You&apos;re all set to manage your new account online with the username
      shown here. Give this information a once-over — you can edit it later in
      your{' '}
      <TextBody tag="span" weight="bold" size="md">
        Profile and Settings
      </TextBody>
      .
    </StyledTextBody>
  ) : (
    <StyledTextBody size="sm" tag="p">
      You&apos;re all set to manage your new account online with the username
      shown here. Visit your Profile and Settings to make sure your account info
      and preferences are up to date.
    </StyledTextBody>
  )
  const { hostServices } = useTransmit()

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Migration Confirmation',
    })
  }, [])
  return (
    <>
      <LoginHeading title="We added your new account." />

      <Space mb="lg">{textBodyBlock}</Space>

      <AccountDetails username={username} userData={userData} />

      <Button
        allytmln="goToSnapshot"
        loading={status === 'Loading'}
        onClick={onComplete}
        text="Continue"
        type="submit"
        variant="primary"
      />
    </>
  )
}

export const AddAutoAccountSuccess: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AddAutoAccountSuccess') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AddAutoAccountSuccessContent {...activeScreen.payload} />
}
